import { Inline, Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Tile } from "PFComponents/tile";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks";

import css from "./review_section.module.scss";

type ReviewerLabelProps = { name: string; date: string };

export const ReviewerLabel = ({ name, date }: ReviewerLabelProps) => {
  const { formatDateTime } = useDateFormatter();

  return (
    <Tile className={css.label}>
      <Inline alignItems="center" gap="spacingLg">
        <Icon name="check" size="sm" color="paletteGreen0" />
        <Stack alignItems="start" gap="spacingXs">
          <Typography variant="bodyBold">{name}</Typography>
          <Typography variant="bodyBold">{formatDateTime(date)}</Typography>
        </Stack>
      </Inline>
    </Tile>
  );
};
